
// SCRIPTS
import { GeneralHomePage } from './home/home.page'; export { GeneralHomePage };


// STYLES
import './home/home.scss';
import './policy/policy.scss';


